import ToggleThemeButton from "../../../../components/toggleThemeButton/ToggleThemeButton";
import { SettingsRow } from "../settings-row/SettingsRow";

export const ThemeSelector = () => {
    return (
        null
        /* <SettingsRow labelKey="285" className="settings-theme-selector" id="theme-selector">
            <ToggleThemeButton id="theme-selector-button" />
        </SettingsRow> */    
    )
}

